module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Por si no lo sabes","track":"Just so you know"}}